var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import WixComponent from '../BaseComponents/WixComponent';
import styles from './PopoverMenuItem.scss';
import typography from '../../src/Typography';
import classNames from 'classnames';

var PopoverMenuItem = function (_WixComponent) {
  _inherits(PopoverMenuItem, _WixComponent);

  function PopoverMenuItem() {
    _classCallCheck(this, PopoverMenuItem);

    return _possibleConstructorReturn(this, (PopoverMenuItem.__proto__ || Object.getPrototypeOf(PopoverMenuItem)).apply(this, arguments));
  }

  _createClass(PopoverMenuItem, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'li',
        { className: classNames(typography.t3, styles.menuItem) },
        React.createElement(
          'button',
          { type: 'button', className: styles.button, onClick: this.props.onClick },
          React.createElement(
            'span',
            { className: styles.icon },
            this.props.icon
          ),
          React.createElement(
            'span',
            { className: styles.text },
            this.props.text
          )
        )
      );
    }
  }]);

  return PopoverMenuItem;
}(WixComponent);

PopoverMenuItem.propTypes = {
  icon: PropTypes.node,
  text: PropTypes.string,
  onClick: PropTypes.func
};


export default PopoverMenuItem;
//# sourceMappingURL=PopoverMenuItem.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/PopoverMenuItem/PopoverMenuItem.js